<template>
    <v-app-bar class="appBar-container">
        <div
            class="d-flex align-center justify-space-between"
            style="width: 100%">
            <!-- Izquierda -->
            <a href="/pacientes">
                <v-img
                    :src="require('@/assets/logo.png')"
                    class="image-icon"></v-img>
            </a>

            <!-- Centro -->
            <div
                class="center-location"
                style="
                    display: flex;
                    align-items: center;
                    justify-content: center;
                "
                v-if="branch">
                <span
                    class="mdi mdi-map-marker"
                    style="font-size: 30pt; margin-right: 10px"></span>
                <span>Sucursal {{ branch }}</span>
            </div>

            <!-- Derecha -->
            <v-menu>
                <template v-slot:activator="{ props }">
                    <div class="menu-column">
                        <v-btn v-bind="props" class="custom-menu">
                            <div class="no-uppercase">
                                <v-icon
                                    class="icon-menu"
                                    style="margin-right: 12px">
                                    mdi-account-circle
                                </v-icon>
                                <span>{{ username }}</span>
                                <v-icon right class="icon-menu">
                                    mdi-menu-down
                                </v-icon>
                            </div>
                        </v-btn>

                        <div class="text-overlay">
                            *Para uso exclusivo de profesionales de la salud.
                        </div>
                    </div>
                </template>
                <v-list>
                    <v-list-item @click="handleClick">
                        <v-list-item-title class="item-title"
                            ><v-icon class="mr-2">mdi mdi-account</v-icon
                            >Perfil</v-list-item-title
                        >
                    </v-list-item>
                    <v-list-item
                        v-if="isMedico"
                        @click="handleAuditClick"
                    >
                        <v-list-item-title class="item-title">
                            <v-icon class="mr-2">mdi-eye-outline</v-icon>
                            {{ auditButtonText }}
                        </v-list-item-title>
                    </v-list-item>
                    <v-list-item @click="downloadUserGuide">
                        <v-list-item-title class="item-title"
                            ><v-icon class="mr-2">mdi-book-open-page-variant</v-icon
                            >Ayuda</v-list-item-title
                        >
                    </v-list-item>
                    <v-list-item @click="logoutKeycloak">
                        <v-list-item-title class="item-title"
                            ><v-icon class="mr-2">mdi-logout</v-icon>Cerrar
                            sesión</v-list-item-title
                        >
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>
    </v-app-bar>
</template>

<script>
import axios from 'axios';
import { getLocationByCode } from '@/api/location';
import {endAudit} from "@/api/audit";

export default {
    data() {
        return {
            menu: false,
            branchName: '',
        };
    },
    computed: {
        username() {
            const user = localStorage.getItem('user');
            if (!user) return '';
            return user[0].toUpperCase() + user.slice(1);
        },
        isMedico() {
            try {
                return JSON.parse(localStorage.getItem('roles') || '[]').includes('Medico');
            } catch (error) {
                console.error('Error parsing roles:', error);
                return false;
            }
        },
        branch() {
            return this.branchName;
        },
        isBeingAudited() {
            return localStorage.getItem('isBeingAudited') === 'true';
        },
        auditButtonText() {
            return this.isBeingAudited ? 'Terminar auditoria' : 'Iniciar auditoria';
        },
    },
    created() {
        this.fetchBranch();
    },
    methods: {
        startAudit() {
            this.$router.push({ name: 'StartAudit' });
        },
        endAudit() {
            localStorage.setItem('isBeingAudited', 'false');
            endAudit(localStorage.getItem('session_audit_id'));
            localStorage.removeItem('session_audit_id');
            this.$router.push({ name: 'Pacientes' });
        },
        handleAuditClick() {
            if (this.isBeingAudited) {
                this.endAudit();
            } else {
                this.startAudit();
            }
        },
        logoutKeycloak() {
            const sessionId = localStorage.getItem('kc_session_state');
            if (!sessionId) {
                console.warn('No hay sesión activa para cerrar');
                return;
            }

            axios
                .put(
                    '/api/session/end',
                    { session_id: sessionId },
                    {
                        headers: {
                            Authorization: `Bearer ${this.$keycloak.token}`,
                        },
                    },
                )
                .then(() => {
                    localStorage.clear();
                    window.sessionStorage.clear();
                    this.$keycloak.logout({
                        redirectUri: window.location.origin,
                    });
                })
                .catch((err) => {
                    console.error('Error cerrando sesión:', err);
                    localStorage.clear();
                    this.$keycloak.logout({
                        redirectUri: window.location.origin,
                    });
                });
        },
        handleClick() {
            this.drawer = !this.drawer;
            this.$router.push('/settingsPractitioner');
        },
        openDrawer() {
            this.$emit('open-drawer');
        },
        openSearch() {
            this.showSearch = !this.showSearch;
            this.searchQuery = ''; // Reiniciar la query de búsqueda al abrir/cerrar
        },
        async fetchBranch() {
            const branchCode = localStorage.getItem('number');
            if (!branchCode) {
                return;
            }
            if (this.branchName) {
                return;
            }
            const branchData = await getLocationByCode(branchCode);
            this.branchName = this.toTitleCase(branchData.nombre);
        },
        toTitleCase(str) {
            if (!str || typeof str !== 'string') return '';
            return str
                .toLowerCase()
                .split(' ')
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        },
        downloadUserGuide() {
            const guideUrl = '/documents/Manual de usuario - Recetas.pdf'; // Ruta al manual de usuario
            window.open(guideUrl, '_blank');
        },
    },
};
</script>

<style scoped>
.appBar-container {
    height: 80px;
    padding: 10px;
}

.image-icon {
    width: 200px;
    /* height: 67px; */
}

.center-location {
    font-size: 20pt;
    color: var(--celeste-electrico);
    font-family: 'Amaranth';
}

.menu-column {
    display: flex;
    flex-direction: column;
    align-items: center;
    color: var(--celeste-electrico);
    height: 84px;
}

.custom-menu {
    height: 50px;
    padding-top: 10px;
}

.no-uppercase {
    text-transform: none !important;
    font-size: 24pt;
    font-family: 'Amaranth';
    font-weight: bold;
}

.icon-menu {
    font-size: 22pt;
    padding-bottom: 6px;
}

.text-overlay {
    font-family: var(--font-body);
    color: var(--rojo-carmesi-intenso);
    font-size: 8pt;
    text-transform: none !important;
}

.item-title {
    font-size: 13pt;
    font-family: 'Amaranth';
}
</style>
